import { useSelector } from 'react-redux'
import { Box, Flex, Text, Tooltip, Tag } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { connect, FormikProps } from 'formik'
import { selectRosters } from '@src/features/shift-post-v2/state/shift-post-v2.selectors'
import { useMemo } from 'react'
import { IInviteUpshiftersFormValues } from '../../invite-upshifters-section.types'

interface IConfirmSummaryProps {
  formik?: FormikProps<IInviteUpshiftersFormValues>
}

export const ConfirmSummary = connect<IConfirmSummaryProps>(({ formik }) => {
  const { values } = formik
  const rosters = useSelector(selectRosters)
  const selectedRosters = useMemo(
    () => rosters.filter((roster) => values.roster_ids.includes(roster.id)),
    [rosters, values.roster_ids]
  )

  if (selectedRosters.length === 0) {
    return (
      <Text my='sm' color='muted'>
        No invitations selected.
      </Text>
    )
  }

  return (
    <>
      {selectedRosters.map((item) => (
        <Flex key={item.id} mb='xs' alignItems='center'>
          <FontAwesomeIcon
            icon={faCheck}
            color='#43b94a'
            size='lg'
            style={{ marginRight: '8px' }}
          />
          <Box>
            <Text>{item.name} </Text>
          </Box>
          <Text color='primary' fontWeight='semiBold' ml='xs'>
            {item.members_count} invites
          </Text>
          {item.is_available_for_invite === false && (
            <Tooltip text='None of the Upshifters in this roster are eligible for an invite.'>
              <span>
                <Tag size='small' type='danger' mx='xs'>
                  Unavailable
                </Tag>
              </span>
            </Tooltip>
          )}
        </Flex>
      ))}
    </>
  )
})
